import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbFieldApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbField';
    }

    /**
     * 批量新增或删除
     * @param datas 
     * @returns 
     */
    public dbFieldSaveOrUpdate(datas) {
        return this.send(datas, 'dbFieldSaveOrUpdate', Methods.POST);
    }

    /**
     * 获取表字段
     * @param tableId 
     * @returns 
     */
    public getDbFieldByTableId(tableId) {
        return this.send({ tableId }, 'getDbFieldByTableId', Methods.GET);
    }

    /**
     * 删除字段
     * @param id 
     * @returns 
     */
    public async deleteDbField(id) {
        return await this.send({}, "deleteDbField?id=" + id, Methods.POST);
    }


       /**
     * 获取字段列表
     * @param tableId
     * @param devProd
     */
       public async getFieldByDevProd(tableId, devProd:any='dev') {
        return await this.send({ tableId, devProd }, 'getFieldByDevProd', Methods.GET);
    }




}